export default "__VITE_ASSET__BsBN4t3b__"